import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import { Col, Container, Row } from "reactstrap"

//Import sections
import UserList from "./UserList"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

const UserView = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manage Users | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Users" breadcrumbItem="Manage Users" />
          <UserList />
        </Container>
      </div>
    </React.Fragment>
  )
}

UserView.propTypes = {
  match: PropTypes.object,
}

export default withRouter(UserView)
